<template>
  <div class="app-container">
    <PageTitle title="门票管理" ref="pageTitle" />
    <div class="filter-container">
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="票行ID"
        v-model="listQuery.tc_ticket_id"
        @change="handleTcTicketId"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="票行名称"
        v-model="listQuery.tc_ticket_name"
        @change="handleTcTicketName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="景区名称"
        v-model="listQuery.project_name"
        @change="handleProjectName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="购票姓名"
        v-model="listQuery.buyer_name"
        @change="handleBuyerName"
      ></el-input>

      <el-date-picker
        v-model="listQuery.travel_date"
        type="date"
        placeholder="出行日期"
        value-format="yyyy-MM-dd"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
        @change="handleTravelDate"
      ></el-date-picker>
      <el-select
        clearable
        collapse-tags
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.status"
        placeholder="状态"
        @change="handleStatus"
      >
        <el-option
          v-for="item in orderStatusOptions"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="订单号"
        v-model="listQuery.assign_order_no"
        @change="handleOrder(listQuery.assign_order_no, 1)"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="订单姓名"
        v-model="listQuery.assign_order_name"
        @change="handleOrder(listQuery.assign_order_name, 2)"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="订单手机号"
        v-model="listQuery.assign_order_mobile"
        @change="handleOrder(listQuery.assign_order_mobile, 3)"
      ></el-input>
      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-button
      type="primary"
      size="mini"
      @click="$refs.edit.handleCreate()"
      style="margin-bottom: 10px"
      >批量购票</el-button
    >
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:buyer_info>
        <el-table-column label="购票人信息" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.buyer_info.name }}｜{{ scope.row.buyer_info.mobile }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:status>
        <el-table-column label="门票状态" width="100" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.row.status }} -->
            <template v-if="scope.row.status == 'not_assign'">未派发</template>
            <template v-if="scope.row.status == 'assigned_not_use'">已派发未使用</template>
            <template v-if="scope.row.status == 'assigned_used'">已派发已使用</template>
            <template v-if="scope.row.status == 'refunded'">已退款</template>
            <template v-if="scope.row.status == 'refund_fail '">退款失败</template>
          </template>
        </el-table-column>
      </template>
      <template v-slot:order_info>
        <el-table-column label="派发订单" width="180" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.order_info">
              <p>{{ scope.row.order_info.source }}:{{ scope.row.order_info.order_number }}</p>
              <p>
                {{ scope.row.order_info.contact.name }}:{{ scope.row.order_info.contact.mobile }}
              </p>
            </template>
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleAction(scope.row.pre_ticket_id, 'cancel')"
              v-if="scope.row.status == 'assigned_not_use'"
              >取消派发</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handleAction(scope.row.pre_ticket_id, 'sendMsg')"
              >重发短信</el-button
            >
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
  </div>
</template>

<script>
import { getList, cancel, sendTicketMsg } from '@/api/preTicket'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
export default {
  name: 'PreTicketIndex',
  components: {
    PageTitle,
    Edit
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        tc_ticket_id: '',
        project_name: '',
        tc_ticket_name: '',
        buyer_name: '',
        travel_date: '',
        status: '',
        assign_order_no: '',
        assign_order_name: '',
        assign_order_mobile: ''
      },
      consumeBtnShow: false,
      sn_list: [],
      columns: [
        {
          type: 'index',
          align: 'center',
          label: '门票编号',
          width: '100'
        },
        {
          label: '票行ID',
          width: '150',
          prop: 'tc_ticket_id'
        },

        {
          label: '项目名称',
          // slot: 'product'
          width: '200',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '票行名称',
          width: '160',
          prop: 'tc_ticket_name',
          showOverflowTooltip: true
        },
        {
          label: '数量',
          width: '80',
          prop: 'ticket_num',
          align: 'center'
        },

        {
          label: '单价',
          width: '100',
          prop: 'ticket_unit_price',
          align: 'center'
        },
        {
          label: '旅游日期',
          width: '120',
          prop: 'travel_date',
          align: 'center'
        },

        {
          label: '购票人信息',
          slot: 'buyer_info'
        },
        {
          label: '入园辅助码',
          width: '160',
          prop: 'ticket_code_address'
        },
        {
          label: '下单时间',
          prop: 'add_time',
          width: '160',
          align: 'center'
        },

        {
          label: '门票状态',
          slot: 'status'
        },

        {
          label: '派发订单',
          slot: 'order_info'
        },
        {
          label: '短信内容',
          prop: 'sms_content',
          width: '200',
          showOverflowTooltip: true
        },

        {
          label: '操作',
          slot: 'action'
        }
      ],
      orderStatusOptions: [
        { name: '未派发', value: 'not_assign' },
        { name: '已派发未使用', value: 'assigned_not_use' },
        { name: '已派发已使用', value: 'assigned_used' },
        { name: '已退款', value: 'refunded' },
        { name: '退款失败', value: 'refund_fail' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true

      getList(this.listQuery).then((res) => {
        console.log(res.data.results)
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },

    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleTcTicketId(e) {
      this.listQuery.tc_ticket_id = e
      this.handleFilter()
    },
    handleTcTicketName(e) {
      this.listQuery.tc_ticket_name = e
      this.handleFilter()
    },
    handleProjectName(e) {
      this.listQuery.project_name = e
      this.handleFilter()
    },
    handleBuyerName(e) {
      this.listQuery.buyer_name = e
      this.handleFilter()
    },
    handleTravelDate(e) {
      this.listQuery.travel_date = e
      this.handleFilter()
    },
    handleStatus(e) {
      this.listQuery.status = e
      this.handleFilter()
    },
    handleOrder(e, type) {
      if (type === 1) {
        this.listQuery.assign_order_no = e
      } else if (type === 2) {
        this.listQuery.assign_order_name = e
      } else {
        this.listQuery.assign_order_mobile = e
      }
      this.handleFilter()
    },

    /**
     * @description:
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        tc_ticket_id: '',
        project_name: '',
        tc_ticket_name: '',
        buyer_name: '',
        travel_date: '',
        status: ''
      }
      this.fetchData()
    },

    /**
     * @description: 取消派发
     * @return {*}
     */
    handleCancel(pre_ticket_id) {
      const _this = this
      _this
        .$confirm('确认取消当前派发么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          cancel(pre_ticket_id).then(() => {
            _this.$notify({
              title: '成功',
              message: '取消派发成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },

    handleAction(pre_ticket_id, type) {
      const msg = type === 'cancel' ? '确认取消当前派发么？' : '确认重新发送短信么？'

      const _this = this
      _this
        .$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          const d = type === 'cancel' ? cancel(pre_ticket_id) : sendTicketMsg(pre_ticket_id)
          d.then(() => {
            _this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
.el-button {
  margin-bottom: 5px;
  margin-left: 0;
  margin-right: 5px;
}
</style>
